<template>
	<div class="container">
		<section>
			<h2>Features</h2>
			<Slider v-for="(value, key, index) in toggles" :key="index" @change-made="trigger" :label="key"/>
		</section>
		<hr/>
		<section>
			<h2>Blog</h2>
		</section>
		<hr/>
		<section>
			<h2>Updates</h2>
		</section>
		<hr/>
		<section>
			<h2>Code</h2>
		</section>
	</div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import Slider from '../components/Slider'

export default {
	name: 'Admin',
	components: {
		Slider
	},
	setup() {
		const store = useStore();
		
		const toggles = computed(() => store.state.toggle);

		function trigger(e) {
			for (let field in e) {
				console.log(e[field])
			}
		}

		onMounted(() => {
			console.log('Fetching settings')
			console.log('Setting up settings')
		})

		return {
			trigger,
			toggles
		}
	}
}
</script>

<style scoped>
hr {
	width: 90%;
	opacity: .5;
}
</style>